import { z } from 'zod';
/**
 * Discriminates whether `reAssigneeId` names a real entity or a pending
 * EntitySuggestion. A `'suggestion'` reassignee writes a placeholder assignment
 * (`assignedTo: { type: 'suggestion', id }`) that the approval/materialize flow
 * later promotes to the resolved entity — only System/OrgFunction go through the
 * suggestion workflow. Shared across the reassign / reject / resolve-unclear
 * mutation contracts so they stay aligned.
 */ export const ReassigneeTypeSchema = z.enum([
    'entity',
    'suggestion'
]);
/**
 * Shared `superRefine` rule: a `'suggestion'` reassignee must target a System
 * or OrgFunction — those are the only entity kinds with a suggestion workflow
 * (there are no person/external-contact suggestions). Applied by every reassign /
 * reject / resolve-unclear request contract so the rule lives in one place.
 */ export function refineSuggestionReassigneeModel(data, ctx) {
    if (data.reAssigneeType === 'suggestion' && data.reAssigneeModel !== 'System' && data.reAssigneeModel !== 'OrgFunction') {
        ctx.addIssue({
            code: 'custom',
            message: 'reAssigneeModel must be "System" or "OrgFunction" when reAssigneeType is "suggestion"',
            path: [
                'reAssigneeModel'
            ]
        });
    }
}
/**
 * Full `superRefine` for the reason-gated reassign contracts (reject-assignment
 * + reassign-recording): when the reason is `'re-assign'` both `reAssigneeId`
 * and `reAssigneeModel` are required, the two must always travel together, and
 * a `'suggestion'` reassignee must target System/OrgFunction. Resolve-unclear has no
 * reason field and makes id+model unconditionally required, so it applies only
 * {@link refineSuggestionReassigneeModel}.
 */ export function refineReassigneeFields(data, ctx) {
    if (data.rejectReason === 're-assign') {
        if (!data.reAssigneeId) {
            ctx.addIssue({
                code: 'custom',
                message: 'reAssigneeId is required when rejectReason is "re-assign"',
                path: [
                    'reAssigneeId'
                ]
            });
        }
        if (!data.reAssigneeModel) {
            ctx.addIssue({
                code: 'custom',
                message: 'reAssigneeModel is required when rejectReason is "re-assign"',
                path: [
                    'reAssigneeModel'
                ]
            });
        }
    }
    // Both id and model must travel together — having one without the other
    // would be ambiguous regardless of reject reason.
    if (data.reAssigneeId && !data.reAssigneeModel || !data.reAssigneeId && data.reAssigneeModel) {
        ctx.addIssue({
            code: 'custom',
            message: 'reAssigneeId and reAssigneeModel must be provided together',
            path: [
                'reAssigneeModel'
            ]
        });
    }
    refineSuggestionReassigneeModel(data, ctx);
}

//# sourceMappingURL=reassignee-type.schema.js.map